// parseVtt + VttCue live in the shared firebase-repository package so the
// meeting cubit and the web app use one parser. formatTimestamp is web-only.
export { parseVtt } from '@breakoutlearning/firebase-repository/util/vtt'
export type { VttCue } from '@breakoutlearning/firebase-repository/util/vtt'

export function formatTimestamp(seconds: number): string {
  const m = Math.floor(seconds / 60)
  const s = Math.floor(seconds % 60)
  return `${m}:${s.toString().padStart(2, '0')}`
}
